import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';
import github from '../../../assets/images/github.svg';
import linkedin from '../../../assets/images/linkedin.svg';

const Footer = () => {
    return (
        <div className='footer'>
            <div className='row'>
                <div className='col-lg-6'>
                    <h4 className='logo footer-logo'><NavLink to='/home'>MR</NavLink></h4>
                </div>
                <div className='col-lg-6'>
                    <div className='footer-btn'>
                        <a href="https://github.com/mishrahat">Github</a>
                        <a href="https://www.linkedin.com/in/misharyrafique/">Linkedin</a>
                        <a href="#about">About</a>
                        <a href="#contact">Contact</a>
                    </div>
                    <div className='mbl-footer-btn'>
                        <a className='github-btn' href="https://github.com/mishrahat"><img src={github} alt="" /></a>
                        <a className='linkedin-btn' href="https://www.linkedin.com/in/misharyrafique/"><img src={linkedin} alt="" /></a>

                    </div>
                </div>
            </div>
            <p className='text-center' style={{ color: 'rgb(138, 136, 136)' }}>Copyright © 2021 Mishary Rafique. All rights reserved</p>
        </div>
    );
};

export default Footer;